import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (path: string, sectionId: string) => {
    if (location.pathname === '/') {
      // 在首页，滚动到对应区域
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // 在其他页面，跳转到对应页面
      navigate(path);
    }
    setIsMobileMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    setIsMobileMenuOpen(false);
  };

  const textColor = isScrolled ? 'text-[#2D2D2D] hover:text-[#C0392B]' : 'text-white hover:text-white/80';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Left: Logo + Name */}
          <div className="flex items-center gap-4 cursor-pointer" onClick={handleLogoClick}>
            <img
              src="https://static.readdy.ai/image/356e0a32a00e968a1405b9eb797d2bd9/9e9696f08c819b8a773f97a5ec4e5326.png"
              alt="Ember Feast Logo"
              className={`h-10 w-auto transition-all duration-300 ${isScrolled ? '' : 'invert'}`}
            />
            <div className="flex flex-col leading-tight">
              <span className={`text-lg font-semibold tracking-widest transition-colors ${isScrolled ? 'text-[#2D2D2D]' : 'text-white'}`}>
                味研社
              </span>
              <span className={`text-xs tracking-[0.2em] uppercase transition-colors ${isScrolled ? 'text-[#C0392B]' : 'text-white/70'}`}>
                YUMMY LAB
              </span>
            </div>
          </div>

          {/* Right: Nav Items */}
          <div className="hidden lg:flex items-center space-x-1">
            <button
              onClick={() => navigate('/reservation')}
              className={`px-5 py-2 text-sm tracking-wide transition-colors ${textColor} cursor-pointer whitespace-nowrap`}
            >
              Reservation
            </button>
            <button
              onClick={() => handleNavClick('/menu', 'menu')}
              className={`px-5 py-2 text-sm tracking-wide transition-colors ${textColor} cursor-pointer whitespace-nowrap`}
            >
              Menu
            </button>
            <button
              onClick={() => handleNavClick('/about', 'about')}
              className={`px-5 py-2 text-sm tracking-wide transition-colors ${textColor} cursor-pointer whitespace-nowrap`}
            >
              About
            </button>
            <button
              onClick={() => handleNavClick('/contact', 'contact')}
              className={`px-5 py-2 text-sm tracking-wide transition-colors ${textColor} cursor-pointer whitespace-nowrap`}
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden p-2 ${isScrolled ? 'text-[#2D2D2D]' : 'text-white'} cursor-pointer`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-1 bg-white rounded-lg shadow-lg p-4">
            {[
              { label: 'Reservation', path: '/reservation', section: 'reservation' },
              { label: 'Menu', path: '/menu', section: 'menu' },
              { label: 'About', path: '/about', section: 'about' },
              { label: 'Contact', path: '/contact', section: 'contact' }
            ].map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavClick(item.path, item.section)}
                className="block w-full text-left px-4 py-3 text-sm text-[#2D2D2D] hover:bg-red-50 hover:text-[#C0392B] transition-colors cursor-pointer whitespace-nowrap rounded"
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}